import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Slider from "react-slick";
import slide1 from "../src/assets/Saraswathi_1.jpg";
import slide2 from "../src/assets/Saraswathi_2.jpg";
import slide3 from "../src/assets/Saraswathi_3.jpg";
import slide4 from "../src/assets/Saraswathi_4.jpg";
import slide5 from "../src/assets/Saraswathi_5.jpg";
import './DetailsCard.css';
import AboutUs from './AboutUs';
import Services from './Services';
import Footer from './Footer';
import ImagePopup from './ImagePopup';

export default function Home() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const status2024 = {
        title: "Financial Status As On 31-03-2026 (Audited)",
        data: [
          { label: "Members", value: "52,431" },
          { label: "Share Capital", value: "₹10.29 Cr" },
          { label: "Owned Funds", value: "₹42.16 Cr" },
          { label: "Working Capital", value: "₹460 Cr" },
          { label: "Deposits", value: "₹414 Cr" },
          { label: "Loans", value: "₹387 Cr" },
          { label: "Business", value: "₹801 Cr" },
          { label: "Net Profit", value: "₹7.27 Cr" },
          { label: "G. NPA", value: "2.45%" },
          { label: "N. NPA", value: "0%" },
          { label: "Branches", value: "20" },
        ],
      };
    
      const status2025 = {
        title: "Financial Status As On 30-09-2026",
        data: [
          { label: "Deposits", value: "₹455.80 Cr" },
          { label: "Loans", value: "₹407.17 Cr" },
          { label: "Working Capital", value: "₹507.41 Cr" },
          { label: "Share Capital", value: "₹10.27 Cr" },
          { label: "Members", value: "53,995" }
        ],
      };

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 100,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1400,
        arrows: !isMobile, // Hide arrows on mobile for cleaner look
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    arrows: false,
                }
            }
        ]
    };

    return (
        <div style={{ overflowX: "hidden" }}> {/* Prevents horizontal scroll */}
            <Navbar />
            <br></br>
            <br></br>
            <div style={{ 
                width: "100%", 
                textAlign: "center", 
                margin: 0, 
                padding: 0, 
                marginTop: isMobile ? "120px" : "140px" 
            }}>
                <Slider {...sliderSettings}>
                    <div>
                        <img
                            src={slide1}
                            alt="Slide 1"
                            style={{ width: "100%", height: "auto", display: "block" }}
                        />
                    </div>
                    <div>
                        <img
                            src={slide2}
                            alt="Slide 2"
                            style={{ width: "100%", height: "auto", display: "block" }}
                        />
                    </div>
                    <div>
                        <img
                            src={slide3}
                            alt="Slide 3"
                            style={{ width: "100%", height: "auto", display: "block" }}
                        />
                    </div>
                    <div>
                        <img
                            src={slide4}
                            alt="Slide 4"
                            style={{ width: "100%", height: "auto", display: "block" }}
                        />
                    </div>
                    <div>
                        <img
                            src={slide5}
                            alt="Slide 5"
                            style={{ width: "100%", height: "auto", display: "block" }}
                        />
                    </div>
                </Slider>
              <ImagePopup/>
        
                <div className="cards-row">
                  
              
      {/* First Card */}
      <div className="card card-left">
        <h2>Welcome to Shri Saraswathi Credit Souharda Sahakari Sangha Ltd</h2>
        <p>
       <b> Saraswathi Sahakari Sangha,</b> which is running parallel to the evolution of the co-operative sector, is entering its 24th year of public service. Since its inception in 2001, the cooperative society has witnessed major events such as demonetization, implementation of GST, merger of banks, covid crisis, natural calamities, etc. After facing all the tests from time to time, today the Co-operative Society has grown into a model in the field of Souharda co-operative sector and is working to provide satisfactory service to the members under the principle of co-operation.
        </p>
        <p>
        Welcoming you warmly to the<b> Saraswathi Parivar</b>, we are happy to give a brief introduction of the Sangha.
        </p>
      </div>

      {/* Second Card */}
      <div className="card card-right">
       
        <h5>
        Financial Status
      </h5>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          gap: isMobile ? "15px" : "20px",
        }}
      >
        {[status2024, status2025].map((status, index) => (
          <div key={index} style={{ border: "1px solid #ddd", padding: isMobile ? "10px" : "15px" }}>
            <h5
              style={{
                textAlign: "center",
                backgroundColor: "#f5f5f5",
                padding: isMobile ? "8px" : "10px",
                borderRadius: "5px",
                fontSize: isMobile ? "12px" : "14px",
              }}
            >
              {status.title}
            </h5>
            <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
              {status.data.map((item, i) => (
                <li
                  key={i}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "5px 0",
                    borderBottom: "1px solid #eee",
                    fontSize: isMobile ? "12px" : "14px",
                  }}
                >
                  <span>{item.label}:</span>
                  <span style={{ fontWeight: "bold" }}>{item.value}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      </div>
    </div>
    <AboutUs/>
    <Services/>
            </div>
         
            <Footer/>
        </div>
    );
}